import { render, staticRenderFns } from "./BaseObject.vue?vue&type=template&id=662cf94d&scoped=true"
import script from "./BaseObject.vue?vue&type=script&lang=js"
export * from "./BaseObject.vue?vue&type=script&lang=js"
import style0 from "./BaseObject.vue?vue&type=style&index=0&id=662cf94d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662cf94d",
  null
  
)

export default component.exports